export default {
  h1: {
    fontWeight: 300,
    fontSize: 60,
    letterSpacing: '-0.24px',
    fontFamily: 'Inter',
    color: '#263238'
  },
  h2: {
    fontWeight: 400,
    fontSize: 48,
    letterSpacing: '-0.24px',
    fontFamily: 'Inter',
    color: '#263238'
  },
  h3: {
    fontWeight: 400,
    fontSize: 24,
    letterSpacing: '-0.06px',
    fontFamily: 'Inter',
    color: '#263238'
  },
  h4: {
    fontWeight: 400,
    fontSize: 20,
    letterSpacing: '-0.06px',
    fontFamily: 'Inter',
    color: '#263238'
  },
  h5: {
    fontWeight: 400,
    fontSize: 16,
    letterSpacing: '-0.05px',
    fontFamily: 'Inter',
    color: '#263238'
  },
  h6: {
    fontWeight: 400,
    fontSize: 14,
    letterSpacing: '-0.05px',
    fontFamily: 'Inter',
    color: '#263238'
  },
  overline: {
    fontWeight: 400,
    fontFamily: 'Inter'
  }
};
